import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BuyerSurveyResponse } from '../../../shared/interfaces/survey.interface';
import { SharedDataService } from '../../../shared/services/shared-data-service/shared-data-service';

@Component({
  selector: 'ps-ui-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent {
  @Input() isNewSurvey = false;
  @Input() isLaunchSurvey = false;
  @Input() isRecontactSurvey = false;
  @Output() closeSurvey = new EventEmitter<boolean>();
  @Output() openServiceAccountModal = new EventEmitter<boolean>(false);

  constructor(private readonly sharedService: SharedDataService) {}

  goToDashboard(close: boolean) {
    this.sharedService.setSurveyData({} as BuyerSurveyResponse);
    this.closeSurvey.emit(close);
  }

  selectBuyer(open: boolean) {
    this.openServiceAccountModal.emit(open);
  }
}
